import React from 'react';
import { CircularProgress } from '@mui/material';
import ContentContainer from '../../areas/layout/content-container';
import { PageWrapper } from './profile-styles';
import { ProfileLayout, ProfileRail } from './rail-styles';
import IdentityCard from './identity-card';
import { LowerProfile } from './lower-profile';
import BadgesSection from './badges-section';
import { useAuth } from '../../context/AuthContext';
import { CenterBox } from '../../utils/center-box';
import { NotLoggedIn } from '../../utils/not-logged-in';

export const ProfilePage: React.FC = () => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <ContentContainer>
                <CenterBox>
                    <CircularProgress size={48} />
                </CenterBox>
            </ContentContainer>
        )
    }

    if (!isLoading && !isAuthenticated) {
        return (
            <ContentContainer>
                <NotLoggedIn message="Please log in to access your profile." />
            </ContentContainer>
        );
    }

    return (
        <ContentContainer>
            <PageWrapper>
                <ProfileLayout>
                    <ProfileRail>
                        <IdentityCard />
                        <BadgesSection />
                    </ProfileRail>
                    <LowerProfile />
                </ProfileLayout>
            </PageWrapper>
        </ContentContainer>
    )
}
